import { render, staticRenderFns } from "./uplist-bind-dialog.vue?vue&type=template&id=8bc36bfa&"
import script from "./uplist-bind-dialog.vue?vue&type=script&lang=js&"
export * from "./uplist-bind-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports